import { render, staticRenderFns } from "./DpaAccountListTable.vue?vue&type=template&id=2176725b&"
import script from "./DpaAccountListTable.vue?vue&type=script&lang=js&"
export * from "./DpaAccountListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports